function userInfoUpdate(userInfo) {
    localStorage.setItem(
        "userInfo",
        JSON.stringify(userInfo)
    )
    this.$store.commit("memberUpdate", userInfo);
}

export default userInfoUpdate;